"use strict";
/* globals module */
/**
 * @module meteringCategoryClient
 * @description  Metering Category Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringCategoryClient` uses `meteringCategoryRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var MeteringCategoryClient = /** @class */ (function () {
    function MeteringCategoryClient(meteringCategoryRoute, apiClient, meteringCategoryBatchClient) {
        this.meteringCategoryRoute = meteringCategoryRoute;
        this.apiClient = apiClient;
        this.meteringCategoryBatchClient = meteringCategoryBatchClient;
    }
    Object.defineProperty(MeteringCategoryClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringCategoryRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringCategoryClient.prototype, "batch", {
        get: function () {
            return this.meteringCategoryBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of metering resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example meteringCategoryClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringCategoryClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the metering resource.
     * @method
     * @param id MeteringCategory id which uniquely identifies MeteringCategory resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example meteringCategoryClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringCategoryClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.meteringCategoryRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create metering action has been performed; this action creates a new metering resource.
     * @method
     * @param data An MeteringCategory object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create metering action has been performed.
     * @example meteringCategoryClient.create({
                    category : '<category-name>',
                    unitName : 'Kb',
                    unitFactor: 1,
                    defaultSamplingRate: '<value>', - Defaults: Minute = 1,Hour = 2,Day = 3,Week = 4,Month = 5,Year = 6
                    aggregateFunction: '<value>' - Defaults: None = 0,Count = 1,Avg = 2,Max = 3,Min = 4,Sum = 5
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringCategoryClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update metering action has been performed; this action updates a metering resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringCategoryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapepr.updateParams(meteringCategory);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An meteringCategory object used to update specified MeteringCategory resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // meteringCategory is a resource previously fetched using get action.
                    meteringCategory.defaultSamplingRate = 'Day';
                    meteringCategoryClient.update(meteringCategory)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringCategoryClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a metering resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringCategoryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(meteringCategory);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An meteringCategory object used to update specified MeteringCategory resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // meteringCategory is a resource previously fetched using get action.
                    meteringCategoryClient.remove(meteringCategory)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringCategoryClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    MeteringCategoryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringCategoryRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MeteringCategoryBatchClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringCategoryRoute !== "undefined" && _1.MeteringCategoryRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.MeteringCategoryBatchClient !== "undefined" && _1.MeteringCategoryBatchClient) === "function" ? _c : Object])
    ], MeteringCategoryClient);
    return MeteringCategoryClient;
}());
exports.MeteringCategoryClient = MeteringCategoryClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
